import React, { useEffect, useState } from 'react';
import axios from "../utils/axios";
import { getCookie } from '../utils/common';

const FileUploader = ({ onUploadSuccess, initialImage, uploaderIndex }) => {
    const [filePreview, setFilePreview] = useState(initialImage || "");
    const [fileType, setFileType] = useState(() => detectFileType(initialImage));
    const [isUploading, setIsUploading] = useState(false);

    // Nếu initialImage thay đổi → cập nhật preview + đoán lại file type
    useEffect(() => {
        setFilePreview(initialImage || "");
        setFileType(detectFileType(initialImage));
    }, [initialImage]);

    // Đoán loại file từ đuôi
    function detectFileType(url) {
        if (!url) return "";
        const ext = url.split('.').pop()?.toLowerCase();
        if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext)) return 'image/' + ext;
        if (['mp4', 'webm', 'ogg'].includes(ext)) return 'video/' + ext;
        return "";
    }

    // Upload file lên server
    const uploadFile = async (file) => {
        let token = getCookie('accessToken') || localStorage.getItem('accessToken');
        const formData = new FormData();
        formData.append("file", file);
        formData.append("isAvatar", "true");

        try {
            setIsUploading(true);
            const response = await axios.post("/api/v1/uploadfile/file", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    "Authorization": `Bearer ${token}`
                },
            });

            if (response.data?.fileUrl) {
                onUploadSuccess(response.data.fileUrl, uploaderIndex);
                setFilePreview(response.data.fileUrl);
                setFileType(file.type); // Giữ lại type ảnh/video sau upload
            } else {
                throw new Error("Không nhận được URL từ server.");
            }
        } catch (error) {
            console.error("Lỗi upload:", error);
            alert("Upload thất bại!");
        } finally {
            setIsUploading(false);
        }
    };

    // Khi chọn file từ input
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const previewUrl = URL.createObjectURL(file);
            setFilePreview(previewUrl);
            setFileType(file.type);
            uploadFile(file);
        }
    };

    // Khi kéo & thả file
    const handleDrop = (e) => {
        e.preventDefault();
        const file = e.dataTransfer.files[0];
        if (file) {
            const previewUrl = URL.createObjectURL(file);
            setFilePreview(previewUrl);
            setFileType(file.type);
            uploadFile(file);
        }
    };

    return (
        <>
            <style>
                {`
                .upload-box {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 100px;
                    border: 2px dashed #ccc;
                    border-radius: 10px;
                    cursor: pointer;
                    text-align: center;
                    padding: 10px;
                    overflow: hidden;
                    position: relative;
                    background: #fafafa;
                }

                .media-preview {
                    max-width: 100%;
                    max-height: 100%;
                    border-radius: 8px;
                    object-fit: contain;
                }

                .file-uploader {
                    margin-bottom: 1rem;
                }
                `}
            </style>

            <div
                className="file-uploader"
                onDrop={handleDrop}
                onDragOver={(e) => e.preventDefault()}
            >
                <label htmlFor={`fileInput_${uploaderIndex}`} className="upload-box">
                    {filePreview ? (
                        fileType.startsWith("video/") || filePreview.match(/\.(mp4|webm|ogg)$/i) ? (
                            <video src={filePreview} className="media-preview" controls />
                        ) : (
                            <img src={filePreview} alt="Preview" className="media-preview" />
                        )
                    ) : (
                        <span>Kéo & thả hoặc bấm để chọn ảnh/video</span>
                    )}
                </label>

                <input
                    id={`fileInput_${uploaderIndex}`}
                    type="file"
                    accept="image/*,video/*"
                    onChange={handleFileChange}
                    disabled={isUploading}
                    style={{ display: "none" }}
                />

                {isUploading && <p>Đang tải lên...</p>}
            </div>
        </>
    );
};

export default FileUploader;